import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import '../../../Style/EditModal.scss';
import "../../../Style/TableStyle.scss"
import '../../../Style/__searchbar.scss'
import '../../../Style/__button.scss'
import '../../../Style/AccountingSheetStyle.scss'
import { deleteAlert, errorAlert, handleSuccess } from "../../../Components/Alerts";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { ApiLink } from "../../../APILink/ApiLink";
import authHeader from "../../../Auth/authHeader";
import jwtDecode from "jwt-decode";
import { AiFillAppstore } from "react-icons/ai";
import { Paper } from "@mui/material";
import "jspdf-autotable";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import DataGridWithActions from "../../../Components/DataGridWithActions";
import Autocomplete from "@mui/material/Autocomplete";
import { ElementsParagraph, TitleElements } from "../../../Components/HeadersCRUD-s";
import { AddLinkButton, LinkAndClickButton, AddElementsButton } from "../../../Components/AddElementsButton";
import { gridHeader, MillNormativGrid, } from "./MillNormativGrid";
// import InsertRecepture from '../../../CRUD/Article/InsertArticle';
import ItemFormModal from "../../../NewCRUD/ArticleCRUD/ArticleModal";
import { MdEdit } from "react-icons/md";
import { HeaderPaperComponent } from "../../../Components/HeaderPaperComponent";
import InsertCompoundArticle from "../../StandartProduction/CompoundArticle/InsertCompoundArticle";

export default function MillNormativ(props) {
    const [showDetails, setShowDetails] = useState(true);
    const [isArticleModalOpen, setIsArticleModalOpen] = useState(false);

    const [data, setData] = useState([]);
    const [detailsData, setDetailsData] = useState([]);

    const [articleProductions, setArticlProductions] = useState([]);
    const [simpleArticle, setSimpleArticle] = useState([]);

    const [articleProductionID, setArticleProductionID] = useState(0);
    const [simpeArticleID, setSimpleArticleID] = useState(0);
    const [qty, setQty] = useState(0);
    const [componentNumber, setComponentNumber] = useState(0);
    const [showError, setShowError] = useState(false);
    const [sameArticleError, setSameArticleError] = useState("");

    const headers = authHeader();

    const [formDetailData, setFormDetailData] = useState({
        ArticleComponentsID: "",
        ArticleProductionID: "",
        ArticlesID: "",
        Qty: ""
    });

    const [logedEmail, setLogedEmail] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedToken = jwtDecode(token);
            setLogedEmail(decodedToken.email);
        }
    }, []);

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [showDeleteConfirmationDetails, setShowDeleteConfirmationDetails] = useState(false);

    const [showEditModal, setShowEditModal] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showInserForm, setShowInsertForm] = useState(true);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillNormativi/producedArticle', { headers });
            setData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const handleOpenForm2 = () => {
        setShowInsertForm(true);
        setShowEditForm(false);
    };
    const handleOpenForm1 = () => {
        setShowInsertForm(false);
        setShowEditForm(true);
    };

    const clearEdit = () => {
        setFormDetailData({
            ArticleComponentsID: "",
            ArticleProductionID: "",
            ArticlesID: "",
            Qty: ""
        });

        setShowError(false);
        setSameArticleError("");
        // clearLine();
        handleOpenForm2();
    };

    const closeEditForm = () => {
        setShowDetails(true);
        setShowEditModal(false);
        setFormDetailData({
            ArticleComponentsID: "",
            ArticleProductionID: "",
            ArticlesID: "",
            Qty: ""
        });
        setShowError(false);
        setSameArticleError("");
        handleOpenForm2();
    }

    // Kodi per fshirjen e nje elementi ne databaz 
    // const handleDelete = async (deleteItemId) => {
    //     try {
    //         // const response = 
    //         await axios.delete(
    //             ApiLink.API_URL + 'MillNormativi/deleteNor' + `/${deleteItemId}`, { headers }
    //         );
    //         setShowDeleteConfirmation(false);
    //         deleteAlert("Normativi është fshirë me sukses");
    //         fetchData();
    //     } catch (error) {
    //         deleteAlert("Normativi nuk është fshirë");
    //     }
    // };

    const handleDelete = async (deleteItemId) => {
        try {
            await axios.delete(`${ApiLink.API_URL}MillNormativi/deleteNor/${deleteItemId}`, {
                headers
            });

            setShowDeleteConfirmation(false);
            deleteAlert("Normativi është fshirë me sukses");
            fetchData();
        } catch (error) {
            setShowDeleteConfirmation(false);

            if (error.response && error.response.data && error.response.data.message) {
                // Ky është mesazhi nga backend-i
                deleteAlert(error.response.data.message);
            } else {
                // Nëse nuk ka mesazh specifik nga backend
                deleteAlert("Ndodhi një gabim gjatë fshirjes.");
            }
        }
    };


    const deleteDetailLine = async (deleteItemId) => {
        try {
            // const response = 
            await axios.delete(
                ApiLink.API_URL + 'Normativi' + `/${deleteItemId}`, { headers }
            );
            setShowDeleteConfirmation(false);
            deleteAlert("Receptura u fshi me sukses");
            fetchrecepture(componentNumber);
        } catch (error) {
            deleteAlert("Receptura u fshi me sukses");
        }
    };

    const fetchArticlesProduction = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'CompoundArticle', { headers });
            setArticlProductions(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchSimpleArticles = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'article', { headers });
            setSimpleArticle(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const handleNewSubmit = (event) => {
        event.preventDefault();

        if (!simpeArticleID) {
            errorAlert("Ju lutem zgjedhni artikullin e thjeshtë");
            return;
        }
        if (qty > 1) {
            errorAlert("Ju lutem plotësoni sasinë");
            return;
        }

        const stateDate = {
            ArticleProductionID: articleProductionID,
            ArticlesID: simpeArticleID,
            ComponentsName: componentsName,
            ComponentNumber: componentNumber,
            Qty: qty,
            CreatedByUser: logedEmail,
        };

        axios.post(ApiLink.API_URL + "MillNormativi", stateDate, { headers })
            .then(() => {
                handleSuccess("Receptura u shtua me sukses");
                fetchrecepture(componentNumber);
                setSimpleArticleField(null);
                setQty(0);
                setSameArticleError("");
                setShowError(false);
            })
            .catch((error) => {
                errorAlert("Ndodhi një gabim i panjohur.");

                if (error.response) {
                    errorAlert("Ndodhi një gabim i panjohur.");
                }

                if (error.response && error.response.status === 409) {
                    errorAlert(error.response.data);
                } else if (error.response && error.response.status === 400) {
                    errorAlert("Të dhënat nuk janë të sakta. Kontrolloni nëse keni plotësuar çdo fushë.");
                } else {
                    errorAlert("Ndodhi një gabim i panjohur.");
                }
            });
    };

    const handleEditDetails = (item) => {
        handleOpenForm1();
        setShowError(false);
        setSameArticleError("");
        setSimpleArticleField(null);
        setQty(0);
        setFormDetailData({
            ArticleComponentsID: item.ArticleComponentsID,
            ArticleProductionID: item.ArticleProductionID,
            ArticlesID: item.ArticlesID,
            Qty: item.Qty,
        });
    };

    const [componentsName, setComponentName] = useState("");
    // Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        setArticleProductionID(item.ArticleProductionID);
        setComponentNumber(item.ComponentNumber);
        setComponentName(item.ComponentsName);
        fetchrecepture(item.ComponentNumber);
        setShowEditModal(true);
        setShowDetails(false);
        handleOpenForm2();

    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChangeDetail = (event) => {
        const { name, value } = event.target;
        setFormDetailData({ ...formDetailData, [name]: value });
    };

    const handleSubmitDetailLine = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'MillNormativi', formDetailData, { headers })
            .then((response) => {
                fetchrecepture(componentNumber);
                handleOpenForm2();
                setSameArticleError("");
                setShowError(false);
            })
            .catch((error) => {
                // console.log(error);
                errorAlert("Deshtoi editimi i recepturës")
            });
    }

    const fetchrecepture = async (nr) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillNormativi/articlesComponents', {
                headers,
                params: { componentNumber: nr }
            });

            setDetailsData(response.data);
            return response.data || [];
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage || "Gabim nga serveri."}`);
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen me internetin ose provoni më vonë.");
            } else {
                errorAlert(`Gabim: ${error.message}`);
            }

            return [];
        }
    };

    const rows = data.map((item, index) => ({
        id: ++index,
        comNumber: item.ComponentNumber,
        name: item.ComponentsName,
        art: (`${item.Barcode}-${item.ArticleName}`),
        deleteItemId: item.ComponentNumber,
        rowInfo: item
    }));


    const detailsRow = detailsData.map((item, index) => ({
        id: ++index,
        barcode: item.Barcode,
        name: item.ArticleName,
        unit: item.UnitName,
        qty: item.Qty,
        rowInfo: item,
        deleteItemId: item.ArticleComponentsID
    }));

    const [simpleArticleField, setSimpleArticleField] = useState(null);
    const handleAutocompleteChangeSimpleArticle = (event, value) => {
        if (value && value.ArticleID) {
            // Kontrollo nëse ekziston `value.Barcode` në `data`

            setSimpleArticleID(value.ArticleID);
            setSimpleArticleField(value);
            const exists = detailsData.some(item => item.Barcode === value.Barcode);

            if (exists) {
                setSameArticleError("Kjo recepturë është përdorur në këtë listë, ju vetëm mund ta editoni atë");
                setShowError(true);
                return;
            }
            setSameArticleError("");
            setShowError(false);
        } else {
            setSimpleArticleID(0);
            setSimpleArticleField(null);
        }
    };

    const defaultPropsSimpleArticle = {
        options: simpleArticle,
        getOptionLabel: (option) =>
            `${"Recepturë"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{"Recepturë"} <br />
                        <b> {option.ArticleName}</b>
                    </span>
                </li>
            </>
        ),
    };

    //Select list for Clients
    const [compoundArticleField, setCompoundArticleField] = useState(null);
    const handleAutocompleteChangeCompoundArticle = (event, value) => {
        if (value) {
            setSimpleArticleID(value.ArticleID);
            setCompoundArticleField(value);
            const exists = detailsData.some(item => item.Barcode === value.Barcode);
            if (exists) {
                setSameArticleError("Kjo recepturë është përdorur në këtë listë, ju vetëm mund ta editoni atë");
                setShowError(true);
                return;
            }
            setSameArticleError("");
            setShowError(false);
        } else {
            setCompoundArticleField(null);
            setSimpleArticleID(0);

        }
    };

    const defaultPropsCompoundArticles = {
        options: articleProductions,
        getOptionLabel: (option) =>
            `${option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} <br />
                        <b> {option.ArticleName}</b>
                    </span>
                </li>
            </>
        ),
    };

    ////////////////////////
    const handleAutocompleteChangeArticleEdit = (event, value) => {
        if (value) {
            // Kontrollo nëse ekziston `value.Barcode` në `data`
            const exists = detailsData.some(item => item.Barcode === value.Barcode);

            if (exists) {
                setSameArticleError("Kjo recepturë është përdorur në këtë listë, ju vetëm mund ta editoni atë");
                setShowError(true);
                return;
            }
            setFormDetailData(prevState => ({
                ...prevState,
                ArticlesID: value.ArticleID
            }));
            // fetchArticlesSalesPrice(value.ArticleID, "edit");
        } else {
            setFormDetailData(prevState => ({
                ...prevState,
                ArticlesID: ""
            }));
        }
    };

    const defaultPropsArticleEdit = {
        options: simpleArticle,
        getOptionLabel: (option) =>
            `${option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} <br />
                        {option.ArticleName}
                    </span>
                </li>
            </>
        ),
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let nextField;
            switch (e.target.id) {
                case 'ArticlesID':
                    if (showError === true) {
                        nextField = document.getElementById('ArticlesID');

                    }
                    else {
                        nextField = document.getElementById('Qty');
                    }
                    break;
                case 'Qty':
                    if (showEditForm === true && showInserForm === false && showError === false) {
                        handleSubmitDetailLine(e);
                    } else if (showInserForm === true && showEditForm === false && showError === false) {
                        handleNewSubmit(e);
                    }
                    nextField = document.getElementById('ArticlesID');
                    break;
                default:
                    return;
            }
            if (nextField && nextField.select) {
                nextField.focus();
                nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
            }
        }
    };

    useEffect(() => {
        fetchArticlesProduction();
        fetchSimpleArticles();
        fetchData();

    }, [])

    return (
        <div className="AccountingSheet__Container">
            {/* Modal per konfirmin nese deshiron me fshi nje element */}
            <Modal show={showDeleteConfirmation} onHide={() => setShowDeleteConfirmation(false)} style={{ marginTop: "150px" }}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteConfirmationDetails} onHide={() => setShowDeleteConfirmationDetails(false)} style={{ marginTop: "150px" }}>
                <Modal.Header>
                    <Modal.Title>Confirmation 2</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmationDetails(false)}>
                        No
                    </Button>
                    <Button variant="danger" >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
            <br></br>
            <br></br>
            {showEditModal && (
                <div className="SalesDetail__Container">
                    <TitleElements
                        icon={MdEdit}
                        title="Ndryshimi i Normativit"
                    />
                    <hr></hr>
                    <div className="SalesDetail__Container__AllButtons">
                        <div style={{ display: "flex", }}>
                            <div>
                                <InsertCompoundArticle fetchData={fetchArticlesProduction} type="insert" />
                            </div>
                            <div style={{ marginLeft: "5px" }}>
                                {/* <InsertRecepture fetchData={fetchSimpleArticles} type="insert" /> */}
                                <AddElementsButton
                                    text="Krijo Artikull"
                                    onClick={() => setIsArticleModalOpen(true)}
                                    icon="bi bi-upc-scan"
                                    className="button-15"
                                />
                                <ItemFormModal
                                    isOpen={isArticleModalOpen}
                                    onClose={() => setIsArticleModalOpen(false)}
                                    onSuccess={() => { setIsArticleModalOpen(false); fetchSimpleArticles(); }}
                                    itemToEdit={null}
                                />
                            </div>
                        </div>
                        <div style={{ display: "flex" }}>
                            {/* <div style={{ marginLeft: "5px" }}>
                                <LinkAndClickButton
                                    text="Ndrysho"
                                    // icon={<FaTrash />}
                                    link="#"
                                    onClick={handleSubmit}
                                />
                            </div> */}
                            <div style={{ marginLeft: "5px" }}>
                                <LinkAndClickButton
                                    text="Mbyll"
                                    // icon={<FaTrash />}
                                    link="#"
                                    onClick={() => {
                                        closeEditForm();
                                        // setShowDetails(true);
                                        // setShowEditModal(false);
                                        // setSimpleArticle([]);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className='header_paper2'></div> */}
                    <HeaderPaperComponent />
                    <Paper>
                        <form className='header_paper'>
                            <Box
                                noValidate
                                autoComplete="off"
                            >
                                <div className='AccountingSheet__Container__Form'>
                                    <div style={{ width: "100%", paddingTop: "15px" }}>
                                        {/* <Autocomplete
                                            fullWidth
                                            // sx={{ m: 2 }}
                                            {...defaultPropsCompoundArticles}
                                            id="ArticleCompoundID"
                                            includeInputInList
                                            onChange={handleAutocompleteChangeCompoundArticle}
                                            readOnly
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label="Artikulli i përbërë"
                                                    style={{ width: "100%" }}
                                                />
                                            )}
                                            value={articleProductions.find(option => option.ArticleID === articleProductionID) || null}
                                        /> */}
                                        <TextField
                                            // className="AccountingSheet__Container__Form__TextField__5"
                                            style={{ width: "100%" }}
                                            type="text"
                                            id="ComponentsName"
                                            name="ComponentsName"
                                            label="Emertimi Normativit"
                                            variant="outlined"
                                            autoComplete="off"
                                            value={componentsName}
                                        />
                                        <br></br>
                                        <br></br>
                                        <Autocomplete
                                            fullWidth
                                            {...defaultPropsArticleEdit}
                                            id="ArticlesID"
                                            includeInputInList
                                            onChange={handleAutocompleteChangeArticleEdit}
                                            readOnly
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    style={{ width: "100%" }}
                                                    label="Lënda e parë"
                                                />
                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '200px',
                                                    overflow: 'auto',
                                                },
                                            }}
                                            value={simpleArticle.find(option => option.ArticleID === articleProductionID) || null}
                                        />
                                    </div>
                                </div>
                            </Box>
                        </form>
                        <br></br>
                        <br></br>
                        {showEditForm && (
                            <form onSubmit={handleSubmitDetailLine} className='header_paper' onKeyPress={handleKeyPress}>
                                <Box
                                    sx={{
                                        '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <div className='AccountingSheet__Container__Form'>
                                        <div style={{ width: "90%" }}>
                                            {/* <Autocomplete
                                                fullWidth
                                                {...defaultPropsArticleEdit}
                                                id="ArticlesID"
                                                includeInputInList
                                                onChange={handleAutocompleteChangeArticleEdit}
                                                renderInput={(params) => (
                                                    <TextField {...params}
                                                        style={{ width: "90%" }}
                                                        label="Përzgjedh artikullin e thjeshtë"
                                                    />
                                                )}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '200px',
                                                        overflow: 'auto',
                                                    },
                                                }}
                                                value={simpleArticle.find(option => option.ArticleID === formDetailData.ArticlesID) || null}
                                            /> */}

                                            <Autocomplete
                                                fullWidth
                                                // sx={{ m: 2 }}
                                                {...defaultPropsCompoundArticles}
                                                id="ArticleCompoundID"
                                                includeInputInList
                                                onChange={handleAutocompleteChangeCompoundArticle}
                                                readOnly
                                                renderInput={(params) => (
                                                    <TextField {...params}
                                                        label="Artikulli i prodhuar"
                                                        style={{ width: "90%" }}
                                                    />
                                                )}
                                                value={articleProductions.find(option => option.ArticleID === formDetailData.ArticlesID) || null}
                                            />
                                        </div>
                                        <div className='box3'>
                                            <TextField
                                                className="AccountingSheet__Container__Form__TextField__5"
                                                type="text"
                                                id="Qty"
                                                name="Qty"
                                                label="Sasia"
                                                variant="outlined"
                                                autoComplete="off"
                                                value={formDetailData.Qty}
                                                onChange={handleInputChangeDetail}
                                            />
                                        </div>
                                        <div className="butonat" style={{ paddingTop: "15px" }}>
                                            <div>
                                                <Button type="submit" variant="success" disabled={showError} style={{ borderRadius: "0", width: "45px", height: "45px" }}>
                                                    <i class="bi bi-check-lg"></i>
                                                </Button>
                                            </div>
                                            <div>
                                                <Button variant="danger" onClick={clearEdit} style={{ borderRadius: "0", width: "45px", height: "45px" }}>
                                                    <i class="bi bi-x-lg"></i>
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="responsive">
                                            <div className="responsive__butonat">
                                                <div >
                                                    <Button type="submit" variant="success" disabled={showError} style={{ borderRadius: "0", width: "45px", height: "45px" }}>
                                                        <i class="bi bi-check-lg"></i>
                                                    </Button>
                                                </div>
                                                <div>
                                                    <Button variant="danger" onClick={clearEdit} style={{ borderRadius: "0", width: "45px", height: "45px" }}>
                                                        <i class="bi bi-x-lg"></i>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {showError && <span style={{ color: "red" }}>{sameArticleError}</span>}
                                </Box>
                            </form>
                        )}
                        {showInserForm && (
                            <form onSubmit={handleNewSubmit} className='header_paper' onKeyPress={handleKeyPress}>
                                <Box
                                    sx={{
                                        '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <div className='AccountingSheet__Container__Form'>
                                        <div style={{ width: "90%" }}>
                                            <Autocomplete
                                                fullWidth
                                                {...defaultPropsCompoundArticles}
                                                id="ArticlesID"
                                                includeInputInList
                                                value={compoundArticleField}
                                                onChange={handleAutocompleteChangeCompoundArticle}
                                                isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID}
                                                renderInput={(params) => (
                                                    <TextField
                                                        style={{ width: "90%" }}
                                                        {...params}
                                                        label="Përzgjedh artikullin e prodhuar"
                                                    />
                                                )}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '200px',
                                                        overflow: 'auto',
                                                    },
                                                }}
                                            />

                                        </div>
                                        <div>
                                            <TextField
                                                className="AccountingSheet__Container__Form__TextField__5"
                                                id="Qty"
                                                label="Sasia"
                                                variant="outlined"
                                                autoComplete="off"
                                                name='QTY'
                                                value={qty}
                                                onChange={event => setQty(event.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                        <div className="butonat">
                                            <button type="submit"
                                                className="btn btn-primary float-end"
                                                style={{ background: "#284945", width: "110px", marginLeft: "15px" }}
                                                disabled={showError}
                                            >Shto</button>
                                        </div>
                                    </div>
                                    {showError && <span style={{ color: "red" }}>{sameArticleError}</span>}
                                </Box>
                            </form>
                        )}
                        <DataGridWithActions
                            columns={gridHeader}
                            rows={detailsRow}
                            handleEdit={handleEditDetails}
                            handleDelete={deleteDetailLine}
                            showPayment={false}
                        />
                    </Paper>
                </div>

            )}
            {showDetails && (
                <div className="shfaqePermbajtjen">
                    <div className="header_flex">
                        <TitleElements
                            icon={AiFillAppstore}
                            title="Normativi i mullirit"
                        />
                        <AddLinkButton
                            text="Krijo Normativ mulliri"
                            icon="bi bi-plus-circle"
                            link="/millproduc/newNormativ"
                        />
                    </div>
                    <ElementsParagraph text="Forma e normativit: Menaxhoni, shtoni, editoni dhe fshini normativin." />
                    <DataGridWithActions
                        columns={MillNormativGrid}
                        rows={rows}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        showPayment={false}
                        height={500}
                    />
                </div>
            )}
        </div >
    )
}